export function selectCurrentPeriod(state): (string | undefined) {
  return state.periodSelector
}

const initialState = 'week';

export default {
  namespace: 'periodSelector',

  state: initialState,

  effects: {
    * change({payload = {}}, {put}) {
      yield put({
        type: 'changePeriodSelector',
        payload,
      });
    }
  },

  reducers: {
    changePeriodSelector(state, action) {
      return action.payload
    },
    reset() {
      return initialState
    }
  }
};
